import React from 'react'
import './HomeSection.css'
import {ReactComponent as ArrowBlack} from '../../assets/arrowRightBlack.svg'
import './HomeBtn.css'
import '../about/About.css'
import './Ready.css'

export default function Ready(props) {
    return (
        <div className="readySectionWrapper">

            <div className="readySection">
             
                    <div className="readySectionMain">
                        <h1 className="readySectionSubTitle">
                            <span className="readySectionTitle">¿Ready? </span>
                            Elige una reunión con un experto o cuentanos tu proyecto.
                        </h1>
                    </div>
                    
                    <div className="readySectionSub">
                        <p className="readySectionSubContent" >
                            Elige entre una reunión de 30 minutos con un consultor experto o cuentanos tu proyecto directamente a través del formulario. <b>Todo con la máxima confidencialidad</b>.
                        </p>
                        <div className="readyBtn">
                            <a className= "readyMore" href="/">
                                Contactar con el equipo de ventas<ArrowBlack />
                            </a>
                        </div>

                    </div>
                
            </div>
            


        </div>
    )
}

